<script setup>
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  list: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['edit', 'delete', 'manage-contacts']);

const { t } = useI18n();
</script>

<template>
  <div
    class="flex flex-col p-4 bg-n-solid-2 rounded-xl border border-n-weak hover:border-n-slate-6 transition-colors"
  >
    <div class="flex items-start justify-between mb-3">
      <div class="flex-1 min-w-0">
        <div class="flex items-center gap-2">
          <h3 class="text-base font-semibold text-n-slate-12 truncate">
            {{ list.name }}
          </h3>
          <span
            v-if="list.source === 'ai_generated'"
            class="inline-flex items-center gap-1 px-1.5 py-0.5 text-[10px] font-semibold rounded-full bg-n-violet-3 text-n-violet-11"
          >
            <span class="i-lucide-sparkles text-[10px]" />
            IA
          </span>
        </div>
        <p
          v-if="list.description"
          class="mt-1 text-sm text-n-slate-11 line-clamp-2"
        >
          {{ list.description }}
        </p>
      </div>
    </div>

    <p
      v-if="list.ai_analysis"
      class="mb-3 text-xs text-n-slate-11 leading-relaxed line-clamp-3 p-2 rounded bg-n-violet-2 border border-n-violet-5"
    >
      <span class="font-medium text-n-violet-11">Análise IA:</span>
      {{ list.ai_analysis }}
    </p>

    <div class="flex items-center gap-4 mb-4">
      <div class="flex items-center gap-2">
        <span class="i-lucide-users text-n-slate-10" />
        <span class="text-sm font-medium text-n-slate-11">
          {{ list.contacts_count }} {{ t('CONTACT_LISTS.CONTACTS') }}
        </span>
      </div>
    </div>

    <div class="flex items-center gap-2 mt-auto pt-3 border-t border-n-weak">
      <Button
        size="xs"
        variant="faded"
        color="slate"
        icon="i-lucide-users"
        :label="t('CONTACT_LISTS.ACTIONS.MANAGE')"
        @click="emit('manage-contacts', list)"
      />
      <Button
        size="xs"
        variant="faded"
        color="slate"
        icon="i-lucide-pencil"
        @click="emit('edit', list)"
      />
      <Button
        size="xs"
        variant="faded"
        color="ruby"
        icon="i-lucide-trash-2"
        @click="emit('delete', list)"
      />
    </div>
  </div>
</template>
